<div class="container">
  <div class="row">
<!--    <mat-form-field appearance="outline" class="col-md-4">-->
<!--      <mat-label>Centre</mat-label>-->
<!--      <mat-select multiple [(value)]="centreSelected" (selectionChange)="onCentreSelect($event)">-->
<!--        <mat-option *ngFor="let centre of $mCentres$ | async" [value]="centre.centreCode">{{ centre.centreName-->
<!--          }}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <app-searchable-select class="col-md-4"
                           [multiple]="true"

                           [options]="$mCentres$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <!--            <mat-error *ngIf="startDate?.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
      <!--            <mat-error *ngIf="endDate?.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->
    </mat-form-field>

    <button mat-mini-fab class="col-md-2" (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
    <button class="mx-2" mat-mini-fab color="accent" (click)="Clear()"><mat-icon>clear</mat-icon></button>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Floor</mat-label>
      <mat-select value="All" (selectionChange)="onFloorSelect($event)">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor=" let floor of mFloorArray" [value]="floor">{{floor}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <section>
    <div class="card  p-2">
      <div class="ngxTableHeader ">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Unit & Floor Report</h2>
          </li>
          <li class="dropdown m-l-20">
            <label id="search-input"><i class="material-icons search-icon">search</i></label>
            <input placeholder="Search" type="text" class="browser-default search-field" (keyup)='applyFilter($event)'
              aria-label="Search box" #input>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <!--      <li>-->
          <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
          <!--          <mat-icon class="col-white" >add</mat-icon>-->
          <!--        </button>-->
          <!--      </li>-->
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Unit & Floor Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="../../../../../assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

      <table mat-table [dataSource]="dataSource" matSort id="excel-table">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Centre Column -->
        <ng-container matColumnDef="centre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
          <td mat-cell *matCellDef="let element"> {{element.centre}} </td>
        </ng-container> <!-- Centre Column -->
        <ng-container matColumnDef="transferFrom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Transfer From </th>
          <td mat-cell *matCellDef="let element"> {{element.transferFromUnit}} </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
          <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="transferDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Transfer Date </th>
          <td mat-cell *matCellDef="let element"> {{element.transferDate|date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <!-- Child Code Column -->
        <ng-container matColumnDef="childCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Code </th>
          <td mat-cell *matCellDef="let element"> {{element.childCode}} </td>
        </ng-container>
        <!-- DoA Column -->
        <ng-container matColumnDef="dateOfAdmission">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Admission Date </th>
          <td mat-cell *matCellDef="let element"> {{element.dateOfAdmission|date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="dateOfDischarge">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Discharge Date</th>
          <td mat-cell *matCellDef="let element"> {{element.dateOfDischarge|date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <!-- Unit Column -->
        <ng-container matColumnDef="unit">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit </th>
          <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
        </ng-container>

        <!-- Floor Column -->
        <ng-container matColumnDef="floor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Floor </th>
          <td mat-cell *matCellDef="let element"> {{element.floor}} </td>
        </ng-container>

        <!--        &lt;!&ndash; Action Column &ndash;&gt;-->
        <!--        <ng-container matColumnDef="action">-->
        <!--            <th mat-header-cell *matHeaderCellDef> Action </th>-->
        <!--            <td mat-cell *matCellDef="let element">-->
        <!--                &lt;!&ndash; Add action buttons here &ndash;&gt;-->
        <!--            </td>-->
        <!--        </ng-container>-->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" showFirstLastButtons></mat-paginator>
    </div>
  </section>


</div>
